/**
 * On app load, fetch the live trending risk-keywords list from the backend
 * and update <meta name="keywords"> + add a <meta name="news_keywords">.
 *
 * This boosts SEO freshness without server-side rendering.
 */
import { useEffect } from "react";
import { API } from "@/lib/api";

export default function useDynamicSEOKeywords() {
  useEffect(() => {
    let cancelled = false;
    fetch(`${API}/seo/keywords`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (cancelled || !data?.keywords?.length) return;
        const content = data.keywords.join(", ");
        let tag = document.querySelector('meta[name="keywords"]');
        if (!tag) {
          tag = document.createElement("meta");
          tag.setAttribute("name", "keywords");
          document.head.appendChild(tag);
        }
        tag.setAttribute("content", content);

        // news_keywords is honoured by Google News + helps trending signals
        let news = document.querySelector('meta[name="news_keywords"]');
        if (!news) {
          news = document.createElement("meta");
          news.setAttribute("name", "news_keywords");
          document.head.appendChild(news);
        }
        news.setAttribute("content", data.keywords.slice(0, 10).join(", "));
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
}
